import { BiHome, BiMenu } from "react-icons/bi";
import { FaGlobe } from "react-icons/fa";

let categoryData = [
  {
    id: "3.1",
    name: "Packaging Test Systems",
    href: "/category/packaging-testing-instruments",
  },
  {
    id: "3.2",
    name: "Plastic Test Systems",
    href: "/category/plastic-testing-instruments",
  },
  {
    id: "3.3",
    name: "Environmental Test Systems",
    href: "/category/environmental-testing-instruments",
  },
  {
    id: "3.4",
    name: "Bottle Test Systems",
    href: "/category/bottle-testing-instruments",
  },
];

const MenuItems = [
  {
    id: "1",
    name: "Home",
    href: "/",
    icon: BiHome,
  },
  {
    id: "2",
    name: "About Us",
    href: "/about-us",
    icon: FaGlobe,
  },
  {
    id: "3",
    name: "Products",
    href: "/category",
    icon: BiMenu,
    children: categoryData,
    products: true,
  },
  {
    id: "4",
    name: "Industry Solutions",
    href: "/industry-solutions",
    icon: FaGlobe,
  },

  {
    id: "5",
    name: "Resources",
    href: "/resources",
    icon: BiMenu,
    children: [
      {
        id: "5.1",
        name: "Resources",
        href: "/resources",
      },
      {
        id: "5.2",
        name: "Presto TV",
        href: "/resources/presto-tv",
      },
      {
        id: "5.3",
        name: "Webinars ",
        href: "/resources/webinars",
      },
      // {
      //   id: "5.4",
      //   name: "Blogs/Articles ",
      //   href: "/resources/blogs",
      // },
      {
        id: "5.5",
        name: "FAQs",
        href: "/resources/faq",
      },
    ],
  },
  {
    id: "6",
    name: "Blogs",
    href: "/blogs",
    icon: FaGlobe,
  },
  {
    id: "7",
    name: "Contact Us",
    href: "/contact-us",
    icon: FaGlobe,
  },
];

export default MenuItems;
